<template>
  <div>
    <h5 class="mb-2">
      {{ dataComponent.name }}
    </h5>

    <!-- Tabs -->
    <div class="tabs mt-4">
      <div
        v-for="(tab, index) in tabs"
        :key="tab"
        :class="{'tab-active': index === 0}"
        class="tab-list"
      >
        {{ tab }}
      </div>
    </div>

    <b-row class="mt-5">
      <b-col cols="9">
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <label>Date</label>
            </b-col>
            <b-col cols="9">
              <j-datepicker
                :disabled="true"
                format="MMM dd, yyyy"
                placeholder="Ex. Jan 01, 2019"
              />
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Leave Type</label>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label mr-2"
                >
                  Select All
                </label>
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-multi-select
                :disabled="true"
                placeholder="Select Leave Type"
              />
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Name</label>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-single-select
                :disabled="true"
                placeholder="Select Employee"
              />
              <b-button
                class="btn blue"
              >
                <i class="fa fa-search mr-2" />Search
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>

    <hr>

    <b-button
      class="btn grey btn-import-form"
      disabled
    >
      <i class="fa fa-cloud-download fa-lg"/> Generate xls
    </b-button>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      tabs: [
        'SUMMARY',
        'LEAVE',
      ],
      columns: [
        'EMPLOYEE ID',
        'EMPLOYEE NAME',
        'ORGANIZATION UNIT',
        'LEAVE TYPE',
        'TOTAL QUOTA',
        'CARRY FORWARD',
        'MASS CREDIT/DEBIT',
        'USED QUOTA',
        'END OF MONTH',
        'END OF PERIOD',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  display: flex;
  align-items: center;
  overflow-x: scroll;

  .tab-list {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    color: $gray-1;
    white-space: nowrap;
    padding-bottom: 7px;
    margin-right: 20px;
    border-bottom: 4px solid transparent;

    &.tab-active {
      border-color: $primary;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyLeaveReport.vue